import { initialiseAllSliders } from "../components/sliders";

if (window.acf) {
    window.acf.addAction( "render_block_preview/type=card-list-block", initialiseAllSliders )
} else {
    initialiseAllSliders()
}